module.exports = __webpack_public_path__ + "static/media/Big-K.b74a942e.svg";